import {
  Camera,
  Gem,
  GlassWater,
  Laptop,
  Package,
  Palette,
  ShoppingBag,
  SquareStack,
  Watch,
  Wine,
  type LucideIcon,
} from "lucide-react";

/** One icon per item classification (Home tiles, Vault cards without a photo). */
export const CATEGORY_ICONS: Record<string, LucideIcon> = {
  watch: Watch,
  jewellery: Gem,
  handbag: ShoppingBag,
  camera: Camera,
  laptop: Laptop,
  wine: Wine,
  whisky: GlassWater,
  art: Palette,
  tradingCard: SquareStack,
};

/** Unknown or missing classification. */
export const GENERIC_CATEGORY_ICON: LucideIcon = Package;

export function categoryIcon(classification: string | undefined): LucideIcon {
  return (classification && CATEGORY_ICONS[classification]) || GENERIC_CATEGORY_ICON;
}
